import axios from 'axios';
import { Message } from 'element-ui';
import store from '@/store/index.js';
import helper from "@/common/helper";
import i18n from '@/i18n/index'
import router from '@/router'; // 确保正确导入你的路由实例


// create an axios instance
const service = axios.create({
	baseURL: helper.getApiUrl(),
    timeout: 50000, // request timeout
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})

//http request请求拦截
service.interceptors.request.use(config => {
        let tokenInfo = helper.get('tokenInfo');
		const langType = helper.getLang();
		if(langType){
			config.headers['Accept-Language'] = langType;
		}
        // 请求头
        if (tokenInfo) {
            config.headers['api-login-token'] = tokenInfo.token;
            config.headers['api-login-key'] = tokenInfo.token_key;
        }
		
        // post 请求参数
        if (config.method == 'post') {
            config.data = {
                lang: langType,
                ...config.data
            }
        } else if (config.method == 'get') {
            config.params = {
                lang: langType,
                ...config.params
            }
        }
		
        return config
    },
    err => {
        return Promise.reject(err)
    }
)

// respone interceptor
service.interceptors.response.use(
    response => {
        const code = response.data.code;
        if (code * 1 == 1000 || code * 1 == 991 || code * 1 == 101) {
            helper.set("tokenInfo", "");
            store.commit('$vuexSetLoginState', false);
            Message({
                center: true,
                customClass: "errorMessage",
                message: i18n.t(response.data.msg),
                type: "error"
            });

        }
        return response
    },
    error => {
        // Message({
        //     message: i18n.t('请求失败,请刷新后重新操作2'),
        //     center: true,
        //     customClass: "errorMessage",
        //     type: "error"
        // })
        return Promise.reject(error);
    }
)



export default service